import {RampIdType} from '../../../generated/graphql';
import {
  useBetaFeature,
  useBetaFeatureWorkspaceOptimizations,
} from '../../../util/useBetaFeature';
import {useOrgRampFlag} from '../../../util/useRampFlag';

export function useGorillaRunOutliers(
  checkBetaFeature = useBetaFeature,
  checkRampFlag = useOrgRampFlag,
  checkWorkspaceOptimizations = useBetaFeatureWorkspaceOptimizations
) {
  const isFeatureAllowed = checkRampFlag(
    'gorilla-run-outliers',
    RampIdType.OrgName
  );
  const isBetaFlagEnabled = checkBetaFeature(
    'gorilla-run-outliers-available'
  ).isEnabled;
  const isWorkspaceOptimizationsEnabled = checkWorkspaceOptimizations();

  return (
    isFeatureAllowed && isBetaFlagEnabled && isWorkspaceOptimizationsEnabled
  );
}
